export const canvasPathActions = {
    startLoader: "START_UPDATE_CANVAS_PATH_LOADER",
    request: "REQUEST_CANVAS_PATH",
    success: "UPDATE_CANVAS_PATH_SUCESS",
    failure: "UPDATE_CANVAS_PATH_FAILURE",
    reset: "RESET_UPDATE_CANVAS_PATH",
};

export const getCanvasPath = (buyplanId, filename) => {
    return {
        type: canvasPathActions.request,
        payload: {
            buyplanId,
            filename
        },
    };
};

export const getCanvasPathSuccess = (payload) => {
    return {
        type: canvasPathActions.success,
        payload,
    };
};

export const getCanvasPathFailure = (errorPayload) => {
    return {
        type: canvasPathActions.failure,
        payload: errorPayload,
    };
};
